<template>
    <div class="p-20 bg-white">
        <EditUserInfo :user="user" ref="editUserInfo"></EditUserInfo>
        <div style="padding-left:150px">
            <Button type="primary" @click.native="saveUser">保存</Button>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import EditUserInfo from '@/views/components/EditUserInfo'
    import md5 from 'md5'

    export default {
        components: {EditUserInfo},
        data() {
            return {}
        },
        computed: {
            ...mapState({
                user: state => JSON.parse(JSON.stringify(state.custom.user))
            })
        },
        methods: {
            saveUser() {
                if (this.user.setPass === this.user.checkPass) {
                    this.$store.dispatch('custom/postOpChangeData', {userJson: this.user}).then(() => {
                        this.$Message.succes("资料修改成功")
                    })

                    if (this.user.setPass) {
                        this.$store.dispatch('custom/postOpChangePass', {regPassMd5: md5(this.user.setPass)})
                    }
                } else {
                    this.$Message.warning('两次密码不一样');
                }
            }
        }
    }
</script>